<script lang="ts">
    // import src from '../../../assets/local_shipping_FILL0_wght400_GRAD0_opsz24.svg';
    // import src from '../../../assets/Icon awesome-truck.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import TemplateRoundIcon from './TemplateRoundIcon.svelte';
    import { PointOnMap } from '../../components/Planning/VehiclesOnMap/PointOnMap';
    export let scale: number = 1;
    export let title: string = '';
    export let rounded: boolean = false;
    export let backgroundColor: string = '#f92672';

    // scale = scale * 0.9; // fix scale Icon awesome-truck.svg

    let src = PointOnMap.getIconUrl(backgroundColor, 1, 40, 40, 'truck', true);
    scale = scale * 1.2;
</script>

{#if rounded}
    <TemplateRoundIcon {src} {scale} alt={title} hover={title} on:click {backgroundColor} />
{:else}
    <TemplateIcon {src} {scale} alt={title} hover={title} on:click />
{/if}

<!--        styleElement="width:20px; height:20px;"-->
<!--        style="width:65px; height:65px;"-->
